//-------------------------------------------------------------------------------------------------- Imports
import { Row, Card, Typography, Col } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SwipeableButton from "../../components/SwipeableButton";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { resetSignal } from "../../methods/Methods";
import Loading from "../../components/Loading";
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const UpdateSignal = () => {
    const dispatch = useDispatch<AppDispatch>();
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const reset = async () => {
        setIsLoading(true);
        let typeAlert = "";
        await resetSignal(idCliente)
            .then((response) => {
                if (response.data) {
                    if (response.data.data[0].respuesta === "ERROR") {
                        typeAlert = "ERROR";
                    } else {
                        typeAlert = "SUCCESS";
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: response.data.data[0].mensaje,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                }
                setIsLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Lamentamos las molestias, intente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setIsLoading(false);
            });
    }

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            const newIdCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
            setIdCliente(newIdCliente);
        }
    }, [generalData.selectedContract]);
    
    return (
        <>
            <Row style={styles.rowCardPrincipal}>
                <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                    <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot, marginTop: 10 }}>
                        <Row style={{ ...styles.rowRoot, marginBottom: 20 }}>
                            <Col xs={16} style={styles.colRoot}>
                                <Text style={styles.textPrincipal}>
                                    {"Aquí puedes reestablecer tu servicio de Internet y TV, si tienes algunas de las siguientes situaciones:"}
                                </Text>
                            </Col>
                        </Row>
                        <Row style={styles.rowRoot}>
                            <Col xs={16} style={styles.colRoot}>
                                <Text style={styles.textColor}>
                                    {"1) Si no tienes servicio de Internet o TV."}
                                </Text>
                            </Col>
                            <Col xs={16} style={styles.colRoot}>
                                <Text style={styles.textColor}>
                                    {"2) Si tienes intermitencia en tu Internet."}
                                </Text>
                            </Col>
                            <Col xs={16} style={styles.colRoot}>
                                <Text style={styles.textColor}>
                                    {"3) Si te suspendimos el servicio, realizaste tu pago y aun no tienes señal."}
                                </Text>
                            </Col>
                        </Row>
                        <Row style={styles.rowRoot}>
                            <Col xs={16} style={styles.colRoot}>
                                <SwipeableButton
                                    onSuccess={reset}
                                    color='#0055c2'
                                    text='Deslice para confirmar'
                                />
                            </Col>
                        </Row>
                        {isLoading ?
                            <Loading />
                            : null
                        }
                    </Card>
                </Col>
            </Row>
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    rowCardPrincipal: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'center',
    },
    colRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 5
    },
    rowRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
    },
    textPrincipal: {
        textAlign: 'center',
        fontFamily: "Montserrat",
        fontWeight: 600,
        fontSize: 14
    },
    textColor: {
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: '#105fc5',
        textAlign: 'center'
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default UpdateSignal;
